/**
 * Core global JS.
 */
import objectFitImages from 'object-fit-images';
import { ComponentManager } from 'js-component-framework';

// Components
import siteNavigationConfig from '../components/Header/siteNavigationConfig';
import pushNavConfig from '../components/Header/pushNavConfig';
import searchConfig from '../components/SiteSearch';
import learnMoreConfig from '../components/LearnMore/learnMoreConfig';
import buttonDropdownMenuConfig
  from '../components/ButtonDropdownMenu/buttonDropdownMenuConfig';
import searchFacetsConfig from '../components/SearchFacets/searchFacetsConfig';

// Import SCSS
import '../../scss/site/loader.scss';

// Set up component manager
const manager = new ComponentManager('prb-2017');

const configs = [
  siteNavigationConfig,
  pushNavConfig,
  searchConfig,
  buttonDropdownMenuConfig,
  learnMoreConfig,
  searchFacetsConfig,
];

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents(configs);
  objectFitImages();
});

if (module.hot) {
  module.hot.accept();
  manager.initComponents(configs);
}



// WEBPACK FOOTER //
// ./client/js/site/site.js